<template>
    <div class="date-question">
        <label><slot name="label"></slot></label>
        <input type="date" v-model="currentValue" @focus="focus" @input="validateDate" />
        <span v-if="error">{{ error }}</span>
    </div>
</template>

<script>
export default {
    name: "date-question",
    props: {
        value: {
            type: String,
            default: "",
        },
    },
    data: function () {
        return {
            currentValue: this.value,
            error: null,
            valid: null,
        };
    },
    methods: {
        setValue: function (value) {
            if (this.currentValue == value) {
                this.currentValue = null;
            } else {
                this.currentValue = value;
            }
            this.$emit("change", this.currentValue);
        },
        focus: function () {
            this.$emit("focus", this);
        },
        getValue: function () {
            return this.currentValue;
        },
        isValid: function () {
            return this.valid;
        },
        isNull: function () {
            return !this.currentValue;
        },
        validateDate: function () {
            const date = new Date(this.currentValue);
            if (isNaN(date.getTime())) {
                this.error = "Data inválida";
                this.valid = false;
            } else {
                this.error = null;
                this.valid = true;
            }
            this.$emit("change", this.currentValue);
        },
    },
    watch: {
        value: function (newValue) {
            this.currentValue = newValue;
            this.validateDate();
        },
        currentValue(newValue) {
            this.$emit("change", newValue);
        },
    },
};
</script>

<style scoped>
.date-question {
    display: flex;
    flex-direction: column;
}

.date-question input {
    margin-top: 5px;
}

.date-question span {
    color: red;
    margin-top: 5px;
}
</style>
